import { BaseMarket } from './baseMarket'
import { BN } from '@coral-xyz/anchor';
import { PublicKey } from '@solana/web3.js';
import { PRICE_PRECISION, MarketType, OrderTriggerCondition, convertToNumber, BASE_PRECISION, OrderType, DriftClient, BulkAccountLoader, initialize, PositionDirection, OrderSubscriber } from "@drift-labs/sdk"
import { getMarkets24h, getTrades } from "@/api/drift"
import { getSolanaConnection, signTransactionSolana } from "@/init"
import { getSpotList, getMarkets, getKline } from "@/api/perp";
import iconDrift from "@/assets/images/icon-drift.png";
import { webSocketObj } from "./utils/websocket"

class Drift extends BaseMarket {
  name = 'Drift'
  chainCode = 'solana'
  icon = iconDrift
  hasOrderBook = false
  minSize = 0
  defaultSymbol = 'SOL'

  isInit = false
  account = null
  webSocket = null

  async init () {
    this.webSocket = new webSocketObj('wss://dlob.drift.trade/ws')
    while (!this.webSocket.isOpen) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    // this.webSocketPing()
  }
  async webSocketPing () {
    this.webSocket.send({
      "method": "subscribe",
      "subscription": { "type": "allMids" }
    })
    setTimeout(() => {
      this.webSocketPing()
    }, 30 * 1000);
  }

  // constructor() { }
  async initAccount (account) {
    // this.account = '4PkLqzgEMcBKZUiXH9Fxj5poW6WW3B7WoGKPHznTrGnU'
    let solanaConnection = await getSolanaConnection()
    this.account = account
    const env = 'mainnet-beta'
    const sdkConfig = initialize({ env });
    const driftPublicKey = new PublicKey(sdkConfig.DRIFT_PROGRAM_ID);
    const bulkAccountLoader = new BulkAccountLoader(
      solanaConnection,
      'confirmed',
      2000
    );
    this.driftClient = new DriftClient({
      connection: solanaConnection,
      wallet: {
        publicKey: new PublicKey(this.account),
        signTransaction: async (tx) => {
          return await signTransactionSolana(tx)
        }
      },
      env,
      programID: driftPublicKey,
      // accountSubscription: {
      //   type: 'websocket',
      // },
      // accountSubscription: {
      //   type: 'polling',
      //   accountLoader: bulkAccountLoader,
      // },
      userStats: true
      // perpMarketIndexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      // spotMarketIndexes: [0, 1, 2, 3]
      //4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
    });
    await this.driftClient.subscribe();
    this.user = this.driftClient.getUser();
    await this.user.subscribe();
    this.isInit = true
    // this.driftClient.initializeUserAccountAndDepositCollateral
  }

  async getFreeCollateral () {
    await this.getIsInit()
    try {
      let data = this.user.getFreeCollateral()
      let freeCollateral = convertToNumber(data, PRICE_PRECISION);
      // let sdf = BASE_PRECISION.toString()
      // let sdf22 = data.toString()
      return freeCollateral
    } catch (error) {
      return 0
    }
  }
  async getPositions (account, list) {
    await this.getIsInit()
    // if (!list) {
      try {
        list = this.user.getActivePerpPositions()
      } catch (error) {
        return []
      }
    // }
    let positions = []
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      let size = Math.abs(convertToNumber(item.baseAssetAmount, BASE_PRECISION))

      if (!size) continue
      let obj = {
        marketIndex: item.marketIndex,
        size,
        triggerPrice: convertToNumber(item.triggerPrice, PRICE_PRECISION),
        direction: item.baseAssetAmount > 0 ? 'Long' : 'Short',
        liquidationPrice: 0
      }
      if (!obj.size) continue

      obj.price = Math.abs(convertToNumber(item.quoteEntryAmount, PRICE_PRECISION) / obj.size)
      // obj.liquidationPrice = await this.getLiquidationPrice({ marketIndex: item.marketIndex })

      positions.push(obj)
    }
    return positions.filter(item => item.size)
  }
  async getOpenOrders (account, list) {
    await this.getIsInit()
    // if (!list) {
      try {
        list = this.user.getOpenOrders()
      } catch (error) {
        return []
      }
    // }

    let orders = []
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      let size = convertToNumber(item.baseAssetAmount, BASE_PRECISION)
      if (!size) continue

      let obj = {
        marketIndex: item.marketIndex,
        flags: item.reduceOnly ? 'Reduce Only' : '--',
        direction: item.direction.long ? 'Long' : 'Short',
        size,
        sizeUsd: convertToNumber(item.baseAssetAmountFilled, BASE_PRECISION),
        triggerPrice: convertToNumber(item.triggerPrice, PRICE_PRECISION),
        price: convertToNumber(item.price, PRICE_PRECISION),
        orderId: item.orderId
      }

      if (item.orderType.market) {
        obj.orderType = 'Market'
      }

      if (item.orderType.limit) {
        obj.orderType = 'Limit'
      }
      if (item.orderType.triggerMarket && ((obj.direction == 'Long' && item.triggerCondition.above) || (obj.direction == 'Short' && item.triggerCondition.below))) {
        obj.orderType = 'Stop Loss Market'
      }
      if (item.orderType.triggerMarket && ((obj.direction == 'Long' && item.triggerCondition.below) || (obj.direction == 'Short' && item.triggerCondition.above))) {
        obj.orderType = 'Take Profit Market'
      }

      if (item.orderType.triggerLimit && ((obj.direction == 'Long' && item.triggerCondition.above) || (obj.direction == 'Short' && item.triggerCondition.below))) {
        obj.orderType = 'Stop Loss Limit'
      }
      if (item.orderType.triggerLimit && ((obj.direction == 'Long' && item.triggerCondition.below) || (obj.direction == 'Short' && item.triggerCondition.above))) {
        obj.orderType = 'Take Profit Limit'
      }

      if (!obj.orderType) {
        // debugger
        console.log('-------------')
        console.log(item.orderType)
        console.log(item)
        console.log('-------------')
      }
      if (obj.orderType) {
        orders.push(obj)
      }
    }
    return orders
  }
  async getUserTrades () {
    await this.getIsInit()
    let accountPublicKey = this.user.getUserAccountPublicKey()
    let statsAccountPublicKey = this.driftClient.getUserStatsAccountPublicKey()
    console.log(`getUserAccountPublicKey: ${accountPublicKey}`)
    console.log(`getUserStatsAccountPublicKey: ${statsAccountPublicKey}`)

    let { list } = await getTrades(accountPublicKey.toString(), 100)

    let trades = list.map(item => {
      item.direction = item.takerOrderDirection || item.makerOrderDirection
      let obj = {
        marketIndex: item.marketIndex,
        direction: item.direction == 'long' ? 'Long' : 'Short',
        size: convertToNumber(new BN(item.baseAssetAmountFilled), BASE_PRECISION),
        price: convertToNumber(new BN(item.oraclePrice), PRICE_PRECISION),
        fee: convertToNumber(new BN(item.takerFee || item.makerFee), PRICE_PRECISION),
        date: item.ts,
        tx: item.txSig
      }
      return obj
    })

    return trades
  }

  async getLiquidationPrice (params) {
    await this.getIsInit()
    let liquidationPrice
    if (params.size) {
      let p1 = this.driftClient.convertToPerpPrecision(Number(params.size))
      let p2 = this.driftClient.convertToPricePrecision(Number(params.orderPrice))
      liquidationPrice = this.user.liquidationPrice(params.marketIndex, p1, p2)
    } else {
      liquidationPrice = this.user.liquidationPrice(params.marketIndex)
    }
    if (liquidationPrice) {
      let v = convertToNumber(liquidationPrice, PRICE_PRECISION);
      // console.log(`liquidationPrice${JSON.stringify(params)}:${v}=======`)
      return v
    } else {
      return 0
    }


  }
  async calculateFeeForQuoteAmount (params) {
    await this.getIsInit()
    try {
      let fee = this.user.calculateFeeForQuoteAmount(this.driftClient.convertToPricePrecision(Number(params.sizeInUsd)), params.marketIndex)
      let v = convertToNumber(fee, PRICE_PRECISION);
      return v
    } catch (error) {
      return 0
    }
  }

  async getKLine (p) {
    let list = await getKline(p)
    return list
  }

  async deposit (params) {

    await this.getIsInit()
    const amount1 = this.driftClient.convertToSpotPrecision(params.marketIndex, Number(params.amount));
    const associatedTokenAccount = await this.driftClient.getAssociatedTokenAccount(params.marketIndex);
    // https://explorer.solana.com/tx/45guCKYp4ojNDS3VthMoWMpGwVd8tYqmK7USgrYXuomGCDVyTPpBGiCpj2w8vucv8nqXhXrThPYXGsMdjCUoBMKP,ECbfA6uJNmXcUJgk7BZ1Xc35HD7pxJ1ovzTYSQuidJud
    let isUser = await this.user.exists()
    if (!isUser) {

      let referrerInfo = {
        referrer: new PublicKey(process.env.VUE_APP_REFERRER),
        referrerStats: new PublicKey(process.env.VUE_APP_REFERRER_STATS)
      };
      let data = await this.driftClient.initializeUserAccountAndDepositCollateral(amount1, associatedTokenAccount, params.marketIndex, 0, undefined, undefined, referrerInfo)
      if (data && data[0]) {
        return data[0]
      }
      return data
    } else {
      let has = await this.driftClient.deposit(amount1, params.marketIndex, associatedTokenAccount)
      return has
    }


  }
  async withdraw (params) {
    await this.getIsInit()
    const amount1 = this.driftClient.convertToSpotPrecision(params.marketIndex, Number(params.amount));
    const associatedTokenAccount = await this.driftClient.getAssociatedTokenAccount(params.marketIndex);
    let data = await this.driftClient.withdraw(amount1, params.marketIndex, associatedTokenAccount)
    return data
  }
  async getPerpList () {
    try {
      let list = await getMarkets(this.name)
      let sdkList = await await getMarkets24h()
      let marketStar = localStorage.getItem('marketStar')
      if (marketStar) {
        marketStar = JSON.parse(marketStar)
      } else {
        marketStar = []
      }
      let newDatas = list
        .map(item => {
          item.star = marketStar.indexOf(item.symbol) != -1
          let item1 = sdkList.find(o => o.marketIndex == item.marketIndex && o.marketType == 'perp')
          if (item1) {
            let json = {
              ...item1,
              // price: item1.price24hAgo,
              marketIndex: item.marketIndex,
              symbol: item.symbol,
              priceScale: item.priceScale,
              volumeScale: item.volumeScale,
              minSize: item.minSize,
              platform: item.platform,
              leverage: item.leverage,
              icon: item.icon,
            }
            return json
          } else {
            return 0
          }
        })
        .filter(item => item && item.icon)

      return newDatas.sort((a, b) => {
        return (b.star === true) - (a.star === true)
      })
    } catch (error) {
      let ddr = error
      return []
    }
  }
  async getSpotList () {
    let tokens = await getSpotList(this.chainCode, this.name)
    return tokens
  }

  async getPerpPrice (perpList, callback) {

    let updateList = {}
    let subscribeMessage = perpList.map(item => {
      updateList[item.symbol] = {}
      return {
        "type": "subscribe",
        "channel": "orderbook",
        "market": item.symbolOld,
        "marketType": 'perp'
      }
    })
    this.webSocket.send(subscribeMessage)

    this.webSocket.addCallback('getPerpPrice', (message) => {
      if (message.channel && message.channel.indexOf('orderbook') != -1 && message.channel != "heartbeat" && message.data) {
        let data = JSON.parse(message.data)
        if (data.marketType == 'perp') {
          let pair = updateList[data.marketName.split('-PERP')[0]]
          if (pair && data.asks.length && data.bids.length) {
            let price = 0
            try {
              price = (Number(data.asks[0].price) + Number(data.bids[0].price)) / 2 / (10 ** 6)
            } catch (error) {
              debugger
            }
            if (pair.price != price && price) {
              pair.h24Change = 0
              pair.h24ChangePer = 0
              pair.price = price

              let time = (parseInt((new Date().getTime()) / 1000))
              if (time % 5 == 0) {
                callback(JSON.parse(JSON.stringify(updateList)))
              }
            }
          }
        }
      }
    })
  }

  async getSpotPrice (tokenList, callback) {
    let updateList = {}
    let subscribeMessage = tokenList.map(item => {
      updateList[item.symbol] = {}

      return {
        "type": "subscribe",
        "channel": "orderbook",
        "market": item.symbol,
        "marketType": 'spot'
      }
    })
    this.webSocket.send(subscribeMessage)

    this.webSocket.addCallback('getSpotPrice', (message) => {
      if (message.channel && message.channel.indexOf('orderbook') != -1 && message.channel != "heartbeat" && message.data) {
        let data = JSON.parse(message.data)
        if (data.marketType == 'spot') {
          let pair = updateList[data.marketName]
          if (pair && data.asks.length && data.bids.length) {
            let price = 0
            try {
              price = (Number(data.asks[0].price) + Number(data.bids[0].price)) / 2 / (10 ** 6)
            } catch (error) {
              debugger
            }
            if (pair.price != price && price) {
              pair.price = price

              let time = (parseInt((new Date().getTime()) / 1000))
              if (time % 5 == 0) {
                callback(JSON.parse(JSON.stringify(updateList)))
              }
            }
          }
        }
      }
    })
  }

  async subscribeUserTrades (account, callback) {
    await this.getIsInit()
    const eventEmitter = this.user.eventEmitter;
    eventEmitter.on('userAccountUpdate', async data => {

      this.orderSubscriberTime += 1
      console.log('userAccountUpdate========================')
      console.log(this.orderSubscriberTime)
      console.log(data)
      // let positions = await this.getPositions(data.perpPositions)
      // let orders = await this.getOpenOrders()

      callback({
        positions: data.perpPositions,
        orders: data.orders
      })
    });
  }


  async getIsInit () {
    if (this.isInit) return 1
    return await new Promise((r, j) => {
      setTimeout(async () => {
        let k = await this.getIsInit()
        if (k) r(k)
      }, 2000);
    })
  }

  async createOrder (params) {
    await this.getIsInit()

    if (params.addType == 'close') {
      params.direction = params.direction == 'Long' ? 'Short' : 'Long'
      params.orderType = 'Market'
      params.reduceOnly = true
    }

    let orderType = params.orderType ? OrderType[params.orderType.toUpperCase()] : null
    let direction = PositionDirection[params.direction.toUpperCase()]
    let baseAssetAmount = this.driftClient.convertToPerpPrecision(Number(params.size))
    // let oraclePriceOffset = this.driftClient.convertToPricePrecision(.05).toNumber()

    const orderParams = {
      marketIndex: params.marketIndex,
      marketType: MarketType.PERP,
      direction,
      orderType,
      baseAssetAmount,
      // oraclePriceOffset,
      reduceOnly: params.reduceOnly
    }


    if (params.orderType == 'Limit') {
      if (params.price) {
        orderParams.price = this.driftClient.convertToPricePrecision(Number(params.price))
        // let price = this.driftClient.convertToPerpPrecision(Number(params.price))
        // let tr = OrderTriggerCondition[params.direction == 'Long' ? 'BELOW' : 'ABOVE']
        // orderParams.triggerPrice = price
        // orderParams.triggerCondition = tr
      } else {
        throw ('Error')
      }
    }

    let arr = []
    if (params.takeProfitPrice) {
      let takeProfitPrice = this.driftClient.convertToPricePrecision(Number(params.takeProfitPrice))
      let fx = PositionDirection[params.direction == 'Long' ? 'SHORT' : 'LONG']
      let tr = OrderTriggerCondition[params.direction == 'Long' ? 'ABOVE' : 'BELOW']
      let take = {
        marketIndex: params.marketIndex,
        marketType: MarketType.PERP,
        direction: fx,
        orderType: OrderType.TRIGGER_MARKET,
        baseAssetAmount,
        reduceOnly: true,
        triggerPrice: takeProfitPrice,
        triggerCondition: tr
      }
      arr.push(take)
    }
    if (params.stopLossPrice) {
      let stopLossPrice = this.driftClient.convertToPricePrecision(Number(params.stopLossPrice))
      let fx = PositionDirection[params.direction == 'Long' ? 'SHORT' : 'LONG']
      let tr = OrderTriggerCondition[params.direction == 'Long' ? 'BELOW' : 'ABOVE']
      let stop = {
        marketIndex: params.marketIndex,
        marketType: MarketType.PERP,
        direction: fx,
        orderType: OrderType.TRIGGER_MARKET,
        baseAssetAmount,
        reduceOnly: true,
        triggerPrice: stopLossPrice,
        triggerCondition: tr
      }
      arr.push(stop)
    }

    this.orderSubscriberTime = 0
    if (arr && arr.length) {
      if (params.orderType) {
        arr.push(orderParams)
      }
      let data = await this.driftClient.placeOrders(arr)
      await this.setOrderSubscriberTime(params, 0)
      return data
    } else if (params.orderType) {
      let data = await this.driftClient.placePerpOrder(orderParams)
      await this.setOrderSubscriberTime(params, 0)
      return data
    }
    return
  }
  async setOrderSubscriberTime (params, k) {
    if (k > 20) return
    k += 1
    if (params.orderType == 'Market') {
      if (this.orderSubscriberTime < 2) {
        return await new Promise((r, j) => {
          setTimeout(async () => {
            console.log(k)
            r(await this.setOrderSubscriberTime(params, k))
          }, 1000);
        })
      }
    }
    return
  }

  async updateOrder (params) {
    await this.getIsInit()


    let newBaseAmount = this.driftClient.convertToPerpPrecision(Number(params.size))

    const orderParams = {
      orderId: params.orderId,
      newBaseAmount
    }
    if (params.triggerPrice) {
      orderParams.newTriggerPrice = this.driftClient.convertToPricePrecision(+params.triggerPrice)
    }
    if (params.limitPrice) {
      orderParams.newLimitPrice = this.driftClient.convertToPricePrecision(+params.limitPrice)
    }

    let data = await this.driftClient.modifyOrder(orderParams)
    return data
  }
  async cancelOrder (params) {
    await this.getIsInit()
    let data = await this.driftClient.cancelOrder(params.orderId)
    return data
  }
  async getTokenAmounts (account) {
    await this.getIsInit()
    let list = []
    try {
      list = await this.user.getActiveSpotPositions()
    } catch (error) {
      console.log(error)
    }
    list.forEach(item => {
      let sdf = item.scaledBalance.toNumber()
      item.balance = sdf
    })
    for (let i = 0; i < list.length; i++) {
      let item = list[i]
      let sdf = item.scaledBalance.toNumber()
      item.balance2 = sdf
      try {
        let data = await this.user.getTokenAmount(item.marketIndex)
        item.balance = data.toNumber()
      } catch (error) {
        console.log(error)
      }
    }
    return list
  }
  async getTokenAmount (params) {
    await this.getIsInit()
    try {
      let data = await this.user.getTokenAmount(params.marketIndex)
      return data.toNumber() / (10 ** params.decimals)
    } catch (error) {
      console.log(error)
    }
    return 0
  }

  async getOrderBook () {
    return []
  }
}


export const driftObj = new Drift()